import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { Emdash } from "~/components/Punctuation";
import { AssetColumns } from "~/modules/assets/types";
import { AssetTableRowData } from "../types";
import { CatalogReferenceDataSlugs } from "~/modules/catalog/types";
import { BadgeArray } from "~/components/BadgeArray";

// // // //

export const TRANSFERABILITY_TYPES_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.transferabilityTypeIDs,
    label: "Transferability Types",
    tooltip: CatalogReferenceDataSlugs.transferability_type,
    type: ColumnTypes.string,
    width: 200,
    render: (item) => {
        if (!item.isAsset) return null;

        const transferability_types = item.transferability_types ?? [];

        if (transferability_types.length === 0) return <Emdash />;

        return (
            <BadgeArray
                tooltipTitle="Transferability Types"
                values={transferability_types}
                className="gap-3"
            />
        );
    },
};
